module.exports = __webpack_public_path__ + "images/emoji/cn.64d25bfe10f422e5d718.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/cn.png
// module id = 7WC9
// module chunks = 24